"use client";

import Link from "next/link";
import { saveCountryPreference } from "@/lib/hooks/useGeoRedirect";

// Thin client boundary: the homepage is a server component, but picking a
// country must persist the preference for the geo-redirect hook.
export default function CountryCardLink({
  code,
  ariaLabel,
  children,
}: {
  code: string;
  ariaLabel: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={`/${code}`}
      className="card country-card"
      onClick={() => saveCountryPreference(code)}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
}
